import React from 'react';
import PropTypes from 'prop-types';
import MUIBreadcrumbs from '@material-ui/core/Breadcrumbs';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';

const Breadcrumbs = ({ breadcrumbs, linkComponent }) => (
  <MUIBreadcrumbs separator="›">
    {breadcrumbs.map(({ label, path, active }) => {
      if (active) {
        return (
          <Typography variant="caption" color="textSecondary" key={path}>
            {label}
          </Typography>
        );
      }
      return (
        <Link component={linkComponent} to={path} key={path} variant="caption">
          {label}
        </Link>
      );
    })}
  </MUIBreadcrumbs>
);

const breadcrumbShape = PropTypes.shape({
  label: PropTypes.string,
  path: PropTypes.string,
  active: PropTypes.bool,
});

Breadcrumbs.propTypes = {
  breadcrumbs: PropTypes.arrayOf(breadcrumbShape),
  linkComponent: PropTypes.oneOfType([
    PropTypes.element,
    // eslint-disable-next-line react/no-typos
    PropTypes.elementType,
    PropTypes.node,
    PropTypes.string,
    PropTypes.func,
  ]),
};

Breadcrumbs.defaultProps = {
  breadcrumbs: [],
  linkComponent: 'a',
};

export default Breadcrumbs;
